import React, { useState, useCallback } from 'react';
import MultiplePaymentSelector from './MultiplePaymentSelector';

const PaymentModeSelector = ({
  total,
  clientes,
  clienteSeleccionado,
  setClienteSeleccionado,
  onPaymentDataChange
}) => {
  const [multiplePayments, setMultiplePayments] = useState([]);
  const [isMultiplePaymentsValid, setIsMultiplePaymentsValid] = useState(false);

  const handleMultiplePaymentsChange = useCallback((payments, isValid) => {
    setMultiplePayments(payments);
    setIsMultiplePaymentsValid(isValid);
    onPaymentDataChange({
      mode: 'multiple',
      payments,
      isValid
    });
  }, [onPaymentDataChange]);

  return (
    <div className="mt-6 space-y-6">
      <div className="">

        <MultiplePaymentSelector
          total={total}
          onPaymentsChange={handleMultiplePaymentsChange}
          clientes={clientes}
          clienteSeleccionado={clienteSeleccionado}
          setClienteSeleccionado={setClienteSeleccionado}
        />
      </div>
      <div className={`p-3 rounded-lg border ${
        isMultiplePaymentsValid
          ? 'bg-green-50 border-green-200 text-green-700'
          : 'bg-amber-50 border-amber-200 text-amber-700'
      }`}>
        <div className="flex items-center gap-2 text-sm font-medium">
          {isMultiplePaymentsValid ? (
            <>
              <span>✅</span>
              <span>Los pagos están correctamente configurados</span>
            </>
          ) : (
            <>
              <span>⚠️</span>
              <span>Ajusta los montos para que sumen exactamente el total de la venta</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentModeSelector;
